import React, { useRef, useState, useEffect } from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { BtnPrimary } from "../../share/buttons/Btn";
import { useForm } from "react-hook-form";
import Inputs from "../../share/input/Inputs";
import { ReactComponent as Upload } from "../../../Assets/Image/svg/Upload.svg";
import MessageQuill from "../Message/MessageQuill";
import useFetch from "../../../Hooks/useFetch";
import { Modal } from "../../share/modal/Modal";
import UploadFile from "../../share/input/Upload/UploadFile";
import DragAndDrop from "../../share/dragAndDropFile/DragAndDrop";
import parser from "html-react-parser";

const SponsorModal = ({
    close,
    showAnswer,
    data,
    method,
    id,
    load,
    getOrganizer,
}) => {
    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    const [name, setName] = useState();
    const [website, setWebsite] = useState();
    const [description, setDescription] = useState();
    const [pic, setPic] = useState();
    //const [supportCall, setSupportCall] = useState();
    //const [role, setRole] = useState();
    //const [bootcamp, setBootcamp] = useState();
    const [organizerCall, setOrganizerCall] = useState();
    const [modalData, setModalData] = useState({
        organizer_name: "",
        organizer_website: "",
        organizer_description: "",
        organizer_avatar: "",
    });
    const [courses, setCourses] = useState();
    const [upload, setUpload] = useState(false);

    // useEffect(() => {
    //     setName(data?.organizer_name);
    //     setWebsite(data?.organizer_website);
    //     setDescription(data?.organizer_description);
    // }, [data]);

    const submitForm = () => {
        console.log("submitForm");
        const formData = new FormData();
        // if (role === "sponsor" || data?.supporter_name) {
        //     formData.append("supporter_name", name);
        //     formData.append("supporter_website", website);
        //     formData.append("bootcamp", bootcamp);
        //     formData.append("supporter_description", description);
        //     formData.append("supporter_avatar", pic[0]);
        //     setSupportCall(formData);

        //     console.log(parser(description));
        //     method === "put" ? editSupporter.reFetch() : newSupporter.reFetch();
        // }
        formData.append("organizer_name", modalData.organizer_name);
        formData.append("organizer_website", modalData.organizer_website);
        formData.append("organizer_description", description);
        //formData.append("organizer_description", description);
        formData.append("organizer_avatar", pic[0]);
        setOrganizerCall(formData);

        if (method === "POST") {
            console.log("post");
            newOrganizer.reFetch();
            // if (newOrganizer.status === 201) {
            //     console.log("201");
            //     setOrganizerCall();
            //     setName();
            //     setWebsite();
            //     setDescription();
            //     setPic();
            // }
        } else if (method === "PUT") {
            console.log("put");
            editOrganizer.reFetch();
            // if (editOrganizer.status === 200) {
            //     console.log("200");
            //     setOrganizerCall();
            //     setName();
            //     setWebsite();
            //     setDescription();
            //     setPic();
            // }
        }

        close(false);
        //method === "put" ? editOrganizer.reFetch() : newOrganizer.reFetch();
        // editSupporter.reFetch();

        // formData.append("supporter_roll", role);
    };

    // const newSupporter = useFetch({
    //     method: "POST",
    //     url: `BootCampSupporterService`,
    //     noHeader: false,
    //     // caller: getSupporter,
    //     trigger: false,
    //     data: supportCall,
    // });
    // const editSupporter = useFetch({
    //     method: "PUT",
    //     url: `BootCampSupporterService/${id}`,
    //     noHeader: false,
    //     // caller: getSupporter,
    //     trigger: false,
    //     data: supportCall,
    // });
    const editOrganizer = useFetch({
        method: "PUT",
        url: `OrganizerService/${id}`,
        noHeader: false,
        caller: getOrganizer,
        trigger: false,
        data: organizerCall,
    });

    const getOrganizerId = useFetch({
        method: "GET",
        url: `OrganizerService/${id}`,
        noHeader: false,
        trigger: false,
        setter: setModalData,
    });

    const newOrganizer = useFetch({
        method: "POST",
        url: `OrganizerService`,
        noHeader: false,
        caller: getOrganizer,
        trigger: false,
        data: organizerCall,
    });

    const currentCourse = useFetch({
        method: "GET",
        url: "BootCampService/admin_current_bootcamp",
        noHeader: false,
        trigger: true,
        setter: setCourses,
    });

    useEffect(() => {
        id && getOrganizerId.reFetch();
    }, [id]);

    useEffect(() => {
        setDescription(modalData?.organizer_description);
    }, [modalData]);

    const handleModal = () => {
        setUpload((perv) => !perv);
    };

    const handleClose = () => {
        console.log("closed");
        close(false);
        setModalData({
            organizer_name: "",
            organizer_website: "",
            organizer_description: "",
            organizer_avatar: "",
        });
    };

    return (
        <div className="relative">
            <button
                onClick={handleClose}
                className="AddnewsupportTicket-cancel absolute  "
            >
                <div>
                    <Cancel />
                </div>
            </button>
            <h3 className="text-center text-[#77498F] pb-10]">برگزارکنندگان</h3>
            <form className="pt-12" onSubmit={handleSubmit(submitForm)}>
                <input
                    register={{
                        required: { value: true, message: "Enter your Name" },
                    }}
                    type="text"
                    name="name"
                    value={modalData && modalData.organizer_name}
                    control={control}
                    placeholder="نام"
                    onChange={(e) => {
                        setModalData({
                            ...modalData,
                            organizer_name: e.target.value,
                        });
                    }}
                    className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-10 input"
                    //onChange={(e) => {setModalData({...modalData, modalData.organizer_name : })}}
                />
                <input
                    register={{
                        required: { value: true, message: "Enter your Name" },
                    }}
                    type="text"
                    value={modalData && modalData.organizer_website}
                    name="website"
                    control={control}
                    placeholder="وبسایت"
                    className="input border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-10"
                    onChange={(e) =>
                        setModalData({
                            ...modalData,
                            organizer_website: e.target.value,
                        })
                    }
                />

                <MessageQuill
                    placeholder="توضیحات کلی*"
                    value={description}
                    setValue={setDescription}
                />
                {/* {method !== "put" && (
                    <select
                        onChange={(e) => setBootcamp(e.target.value)}
                        className={`border-gray input h-[6.4rem] w-full ${
                            bootcamp ? "text-black" : "text-[#21212199]"
                        } bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[3rem]`}
                    >
                        <option value="" disabled selected>
                            بوت کمپ *
                        </option>
                        {courses?.results.map((course) => {
                            return (
                                <option value={course.id}>
                                    {course.bootcamp_name}
                                </option>
                            );
                        })}
                    </select>
                )} */}
                {/* {method !== "put" && (
                    <div className="flex flex-row">
                        <div className=" flex items-center justify-start ml-[4rem]">
                            <label
                                htmlFor="sponsor"
                                className=" text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center"
                            >
                                <p className="text-[1.7rem] px-5 ml-[5rem] py-16">
                                    نقش مورد نظر:
                                </p>
                                <input
                                    {...register("course", { required: true })}
                                    type="radio"
                                    name="courseType"
                                    value="sponsor"
                                    className="form-check-input PriceForm radio-lg ml-[0.8rem]"
                                    id="4go"
                                    onChange={(e) => {
                                        setRole(e.target.value);
                                    }}
                                />
                                حامی
                            </label>
                        </div>
                        <div className=" flex items-center justify-start ml-[4rem]">
                            <label
                                htmlFor="organizer"
                                className=" text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center"
                            >
                                <input
                                    {...register("course", { required: true })}
                                    // checked
                                    type="radio"
                                    name="courseType"
                                    value="organizer"
                                    className="form-check-input PriceForm radio-lg ml-[0.8rem]"
                                    id="4go"
                                    onChange={(e) => {
                                        setRole(e.target.value);
                                    }}
                                />
                                برگزارکننده
                            </label>
                        </div>
                    </div>
                )} */}
                <div className="flex pb-2">
                    <div
                        onClick={() => handleModal()}
                        className="w-1/2 py-[13px] px-[25px] flex border-gray border-[1px] text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] justify-between cursor-pointer"
                    >
                        <span className="text-gray">بارگذاری لوگو</span>
                        <Upload />
                    </div>
                    <BtnPrimary
                        className="py-[2rem] px-[4rem] flex mr-auto"
                        text="ثبت برگزارکننده"
                    />
                </div>
            </form>

            <Modal show={upload} closeModal={handleModal}>
                <DragAndDrop
                    close={handleModal}
                    label=""
                    {...register("photo", { required: false })}
                    error={errors["photo"]}
                    accept=".png , .jpg"
                    type="image"
                    setFile={setPic}
                />
            </Modal>
        </div>
    );
};

export default SponsorModal;
